import { Injectable } from '@angular/core';
import { Mutation, gql } from 'apollo-angular';


@Injectable({
  providedIn: 'root'
})

export class ReplaceSubscriptionsGQL extends Mutation<ReplaceSubscriptionsGQLResponse, ReplaceSubscriptionsInput> {
  document = gql`
    mutation replacesubscriptions($data: ReplaceSubscriptionsInput!) {
      replaceSubscriptions(data: $data) {
          name
      }
    }
  `;
}

interface ReplaceSubscriptionsInput {
  data: {
    originalProductId: string,
    replacementProductId: string
  };
}

interface ReplaceSubscriptionsGQLResponse {
  replaceSubscriptions: {
    name: string;
  };
}
